// DEPRECATED: This reducer/action/function is not used anymore. Pleasre remove and test.


import { SET_USER_DETAILS } from '../reducers/userDetails';

export const setUserDetails = (data, category) => (dispatch) => {
  dispatch({
    type: SET_USER_DETAILS,
    data,
    category,
  });
};



// WEBPACK FOOTER //
// ./src/actions/userDetails.js